export const InitHeaderSearch = () => {
  const headerEl = document.querySelector<HTMLElement>('.header')
  const searchWidgetEl = document.querySelector<HTMLElement>('.search-widget--desktop')
  const searchWidgetMobileEl = document.querySelector<HTMLElement>('.search-widget--mobile')
  const quickSearchInputEl = document.querySelector<HTMLElement>('.quicksearch-input')!!
  const headerWidgets = document.querySelector<HTMLElement>('.header-widgets')!!
  const searchButtonEl = document.getElementById('header-search-button')!!
  const searchButtonMobileEl = document.getElementById('header-search-button-mobile')!!
  // for later implementation of search flyout
  // const searchFlyoutEl = document.querySelector<HTMLElement>('.search-flyout')!!
  // const searchFlyoutCloseEl = searchFlyoutEl.querySelector<HTMLElement>('.search-flyout-close')!!

  searchWidgetEl?.addEventListener('click', (event: Event) => {
    headerEl?.classList.toggle('search-is-open')

    // wait for transition duration with focus, otherwise stuttering
    setTimeout(() => {
      headerEl?.classList.contains('search-is-open') && quickSearchInputEl.focus()
      searchButtonEl.ariaLabel = headerEl?.classList.contains('search-is-open') ?
        headerWidgets.getAttribute('data-close-search-aria') :
        headerWidgets.getAttribute('data-open-search-aria')
    }, 200)
  })

  searchWidgetMobileEl?.addEventListener('click', (event: Event) => {
    headerEl?.classList.toggle('search-is-open-mobile')

    // wait for transition duration with focus, otherwise stuttering
    setTimeout(() => {
      headerEl?.classList.contains('search-is-open-mobile') && quickSearchInputEl.focus()
      searchButtonMobileEl.ariaLabel = headerEl?.classList.contains('search-is-open-mobile') ?
        headerWidgets.getAttribute('data-close-search-aria') :
        headerWidgets.getAttribute('data-open-search-aria')
    }, 200)
  })

  // for later implementation of search flyout
  // searchFlyoutCloseEl.addEventListener('click', (event: Event) => {
  //   headerEl.classList.remove('search-is-open')
  // })

  document.addEventListener('keydown', (event: KeyboardEvent) => {
    if (event.key == "Escape") {
      headerEl?.classList.remove('search-is-open')
    }
  })

}
